import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import { useMediaQuery } from 'src/lib/use-media-query'
import common from 'src/styles/common.module.scss'

export const TextHeaderIt = () => {
    const isDesktop = useMediaQuery('(min-width: 768px)')

    return (
        <HighlightedText
            text="GIRA LA RUOTA E OTTIENI GIRI GRATUITI"
            highlights={[{ word: 'GIRI' }, { word: 'GRATUITI' }]}
            breakAfterWords={isDesktop ? ['OTTIENI'] : ['RUOTA', 'OTTIENI']}
            className={common.text_header}
        />
    )
}
